import { createContext, useContext } from 'react';

export interface AppSettings {
  Lang: string;
  SetLang: (lang: string) => void;
}

export const AppContext = createContext<AppSettings>({
  Lang: 'ru',
  SetLang: (_: string) => {},
});

const useAppContext = () => {
  const context = useContext(AppContext);
  return context;
};

export default useAppContext;
